module.exports = __webpack_public_path__ + "img/luthi-2.154aa014.jpg";